import React from 'react';
import { Form, Input, Select, Button } from 'antd';

const { Option } = Select;

export default function ProductListFilters(props) {
    const { categories = [], onChange, onReset, onReady } = props;

    return (
        <Form ref={onReady} onChange={onChange} initialValues={{ status: '', category_id: '', sku: '', title: '' }}>
            <div className="row">
                <div className="col-md-3">
                    <Form.Item name="title">
                        <Input placeholder="Tên sản phẩm" />
                    </Form.Item>
                </div>
                <div className="col-md-3">
                    <Form.Item name="sku">
                        <Input placeholder="SKU variant" />
                    </Form.Item>
                </div>
                <div className="col-md-3">
                    <Form.Item name="category_id">
                        <Select placeholder="Danh mục">
                            <Option value="">Tất cả danh mục</Option>
                            {categories.map((item) => <Option key={item._id} value={item._id}>{item.name}</Option>)}
                        </Select>
                    </Form.Item>
                </div>
                <div className="col-md-2">
                    <Form.Item name="status">
                        <Select placeholder="Trạng thái product">
                            <Option value="">Tất cả product</Option>
                            <Option value="active">Active</Option>
                            <Option value="inactive">Inactive</Option>
                        </Select>
                    </Form.Item>
                </div>
                <div className="col-md-1">
                    <Button onClick={onReset}>Xóa lọc</Button>
                </div>
            </div>
        </Form>
    );
}
